// Dates d'un rendez-vous : lecture de « JJ/MM/AAAA HH:MM » ou « JJ/MM/AAAA HH:MM-HH:MM », et cartes à plusieurs dates
// (.card-rdv[data-dates]) : montre la prochaine date à venir et compte les autres.
export function lireDate(s) {
    const m = /(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2}))?/.exec(s || "");
    if (!m) return null;
    return new Date(+m[3], +m[2] - 1, +m[1], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59);
}

// Parmi des éléments portant data-date : ceux à venir, triés, et celui à montrer (le prochain, sinon le dernier passé)
export function trierDates(elements) {
    const maintenant = new Date();
    const tous = elements.map((el) => ({ el, d: lireDate(el.dataset.date) })).filter((x) => x.d).sort((a, b) => a.d - b.d);
    const futurs = tous.filter((x) => x.d >= maintenant);
    return { tous, futurs, choisi: futurs[0] || tous[tous.length - 1] || null };
}

export function pluriel(n, mot) { return `${n} ${mot}${n > 1 ? "s" : ""}`; }

export default function rdv() {
    document.querySelectorAll(".card-rdv[data-dates]").forEach((p) => {
        const dts = [...p.querySelectorAll(".dt")];
        if (dts.length < 2) return;
        const { futurs, choisi } = trierDates(dts);
        if (!choisi) return;
        dts.forEach((el) => { el.hidden = el !== choisi.el; });
        const autres = futurs.length - 1;
        if (autres > 0) {
            const s = document.createElement("span");
            s.className = "autres";
            s.textContent = ` et ${pluriel(autres, "autre")} ${autres > 1 ? "dates" : "date"}`;
            choisi.el.after(s);
        }
    });
}
